import { Navigate, NavLink, Outlet } from 'react-router-dom';
import { useAuth } from '../../auth/auth-context';

const NAV = [
  { to: '/admin', label: 'Dashboard', end: true },
  { to: '/admin/users', label: 'Nutzer' },
  { to: '/admin/invitations', label: 'Einladungen' },
  { to: '/admin/aircraft', label: 'Flugzeuge' },
  { to: '/admin/flights', label: 'Flüge' },
  { to: '/admin/settings', label: 'Settings' },
];

export function AdminLayout() {
  const { user, isLoading, isAuthenticated, isAdmin } = useAuth();

  if (isLoading) {
    return (
      <div className="flex h-full items-center justify-center text-slate-400">
        Lädt …
      </div>
    );
  }
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (!isAdmin) return <Navigate to="/app/flights" replace />;

  return (
    <div className="flex h-full flex-col">
      <header className="sticky top-0 z-10 border-b border-slate-800 bg-slate-900/95 backdrop-blur-md">
        <div className="flex items-center justify-between px-4 py-3">
          <NavLink to="/app/flights" className="text-sm text-brand-400">
            ← App
          </NavLink>
          <h1 className="text-sm font-semibold">Admin</h1>
          <span className="text-xs text-slate-500">
            {user?.firstName} {user?.lastName}
          </span>
        </div>
        <nav className="overflow-x-auto">
          <ul className="flex gap-1 px-2 pb-2 text-xs">
            {NAV.map((item) => (
              <li key={item.to}>
                <NavLink
                  to={item.to}
                  end={item.end}
                  className={({ isActive }) =>
                    `inline-block whitespace-nowrap rounded-full border px-3 py-1.5 transition-colors ${
                      isActive
                        ? 'border-brand-500 bg-brand-600/20 text-brand-200'
                        : 'border-slate-700 bg-slate-800 text-slate-400 hover:text-slate-200'
                    }`
                  }
                >
                  {item.label}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>
      </header>
      <main className="flex-1 overflow-y-auto">
        <Outlet />
      </main>
    </div>
  );
}
